import React from 'react';
import { Checkbox } from 'antd';
import { I18n } from '@aws-amplify/core';
import type { ActionPlanReportWithCount } from '../hooks/useHandleActionPlans';
import * as S from '../styles';

interface ReportSelectionGridProps {
	reports: ActionPlanReportWithCount[];
}

export function ReportSelectionGrid({ reports }: Readonly<ReportSelectionGridProps>) {
	return (
		<>
			{reports.map((report) => {
				const isDisabled = report.count <= 0;

				return (
					<Checkbox key={report.report_name} value={report.custom_report_id} disabled={isDisabled}>
						<S.StyledCheckboxContent>
							<S.ToolContent>
								<S.LeftContent>
									{report.icon && <S.IconWrapper>{report.icon}</S.IconWrapper>}
									<S.NameWrapper>{I18n.get(report.formatted_name)}</S.NameWrapper>
								</S.LeftContent>
								<S.CustomReportsSpan>
									{`${report.count} ${I18n.get('action plans')}`}
								</S.CustomReportsSpan>
							</S.ToolContent>
						</S.StyledCheckboxContent>
					</Checkbox>
				);
			})}
		</>
	);
}
